import apiClient from '../api/apiClient';
import { AxiosResponse } from 'axios';
import type { RoomData, GameType } from '../game/types/game.types';

const roomBaseURL = '/api/room';

// Types matching backend CreateRoomRequest
export interface CreateRoomRequest {
    roomName?: string; // Optional - if not provided, will be auto-generated
    botGame?: boolean;
    gameType?: GameType;
    theme?: string;
    privateRoom?: boolean;
}

// Types matching backend response
export interface CreateRoomResponse {
    success: boolean;
    room: RoomData;
    code: string; // The 5-digit room code
}

export interface CreateRoomErrorResponse {
    success: false;
    error: string;
}

class RoomService {
    /**
     * Create a new game room
     * @param data - Room creation data
     * @returns Promise with created room data including room code
     */
    create(data: CreateRoomRequest): Promise<AxiosResponse<CreateRoomResponse>> {
        return apiClient.post<CreateRoomResponse>(roomBaseURL, data);
    }
}

export default new RoomService();

